import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { subscriptionGuard } from './auth/subscription.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./components/shell/shell.component').then(m => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'cerimoniais',
        canActivate: [subscriptionGuard],
        loadComponent: () => import('./pages/cerimoniais/cerimoniais-lista/cerimoniais-lista.component').then(m => m.CerimoniaisListaComponent)
      },
      {
        path: 'cerimoniais/:id',
        canActivate: [subscriptionGuard],
        loadComponent: () => import('./pages/cerimoniais/cerimoniais-detalhe/cerimoniais-detalhe.component').then(m => m.CerimoniaisDetalheComponent)
      },
      {
        path: 'cerimoniais/:id/controle',
        canActivate: [subscriptionGuard],
        loadComponent: () => import('./pages/cerimoniais/cerimoniais-controle/cerimoniais-controle.component').then(m => m.CerimoniaisControleComponent)
      },
      {
        path: 'atividades',
        canActivate: [subscriptionGuard],
        loadComponent: () => import('./pages/atividades/atividades.component').then(m => m.AtividadesComponent)
      },
      {
        path: 'planos',
        loadComponent: () => import('./pages/planos/planos.component').then(m => m.PlanosComponent)
      },
      { path: '', redirectTo: 'cerimoniais', pathMatch: 'full' }
    ]
  },
  // ── Timer Display — tela cheia pública compartilhável sem shell/navbar ──
  {
    path: 'timer/:id',
    loadComponent: () => import('./pages/cerimoniais/cerimoniais-timer/cerimoniais-timer.component').then(m => m.CerimoniaisTimerComponent)
  },
  {
    path: 'cerimoniais/:id/timer',
    redirectTo: 'timer/:id',
    pathMatch: 'full'
  },
  { path: '**', redirectTo: '' }
];
